import Axios from "axios";

const state = {
    notifications: [],
    notificationCount: 0,
    notificationViewForcedCount: 0
};

const getters = {
    notifications: state => state.notifications,
    notificationCount: state => state.notificationCount,
    notificationViewForcedCount: state => state.notificationViewForcedCount
};

const mutations = {
    setNotifications: (state, data) => state.notifications = data,
    setNotificationCount: (state, data) => state.notificationCount = data,
    setNotificationViewForcedCount: (state, data) => state.notificationViewForcedCount = data
};

const actions = {
    getNotifications: async (context, data) => {
        let response = await Axios.get("/mybremboparts/notification/getnotifications");

        context.commit("setNotifications", response.data);
        context.commit("setNotificationCount", response.data.length);

        return response;
    },
    getNotificationCount: async (context, data) => {
        let response = await Axios.get("/mybremboparts/notification/getnotificationcount");

        context.commit("setNotificationCount", response.data.notificationCount);

        return response;
    },
    getNotificationViewForcedCount: async (context, data) => {
        let response = await Axios.get("/mybremboparts/notification/getnotificationviewforcedcount");

        context.commit("setNotificationViewForcedCount", response.data.notificationViewForcedCount);

        return response;
    },
    setIsRead: async (context, data) => {
        return await Axios.put("/mybremboparts/notification/setisread", data);
    },
    setIsReadAll: async (context, data) => {
        return await Axios.put("/mybremboparts/notification/setisreadall", data);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};